import React, { useState } from "react";
import PropTypes from "prop-types";

import DialogTitle from "ui/DialogTitle";
import DialogActions from "components/DialogActions";

import { Dialog, DialogContent, Box, TextField, Typography } from "@mui/material";

const PublishModal = ({ open, onClose, onPublish }) => {
  const [email, setEmail] = useState("");

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePublish = () => {
    onPublish(email);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle title="Publish your Club" onClose={onClose} />
      <DialogContent>
        <Box sx={{ mb: 3, mt: 1 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Enter your email address to publish your Club and complete setup.
          </Typography>
          <TextField
            label="Email"
            fullWidth
            size="small"
            color="warning"
            onChange={handleEmailChange}
            helperText={
              <>
                Questions? Need help?{" "}
                <a style={{ color: "#F75201" }} href="mailto:hello@membrz.club">We can help.</a>
              </>
            }
            value={email}
          />
        </Box>
      </DialogContent>
      <DialogActions
        onClose={handlePublish}
        disabled={!email}
        ctaText="Publish & Activate Club"
      />
    </Dialog>
  );
};

PublishModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
};

export default PublishModal;
